var render, staticRenderFns
import script from "./CScrollbar.vue?vue&type=script&lang=js"
export * from "./CScrollbar.vue?vue&type=script&lang=js"
import style0 from "perfect-scrollbar/css/perfect-scrollbar.css?vue&type=style&index=0&id=6f130136&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f130136",
  null
  
)

export default component.exports